import React from "react";

import { Flex, Icon, Text, Tooltip } from "@chakra-ui/react";
import { IoHelpCircle } from "react-icons/io5";

const Information = ({ title, information, mt, print, hintText, zIndex }) => {
  return (
    <Flex
      mt={mt ? mt : "15px"}
      flexDirection={{ base: print ? "row" : "column", sm: "row" }}
      gap={print && 2}
      zIndex={zIndex && zIndex}
    >
      <Text
        fontWeight={600}
        fontSize="14px"
        lineHeight="19.6px"
        color="#000"
        whiteSpace="nowrap"
      >
        {title}
      </Text>
      {hintText && (
        <Tooltip label={hintText} fontSize="md" textAlign={"justify"}>
          <span className="hint-tooltip">
            <Icon
              aria-label="Aviso de pendente"
              color="#6B6C71"
              as={IoHelpCircle}
              boxSize={{ base: "18px" }}
            />
          </span>
        </Tooltip>
      )}

      <Tooltip label={information}>
        <Text
          ml={{ base: "0px", sm: "5px" }}
          fontWeight={500}
          fontSize="14px"
          lineHeight="19.6px"
          wordBreak={
            print && title === "Informações Complementares:" && "break-all"
          }
          color="#6B6C71"
          whiteSpace={{
            base:
              !print || title === "Informações Complementares:"
                ? "normal"
                : "nowrap",
            lg: "nowrap",
          }}
        >
          {information}
        </Text>
      </Tooltip>
    </Flex>
  );
};

export default Information;
